export default __webpack_public_path__ + "static/bg-10-dd821c89e25a9fa0b2670f9d1f892ced.jpg";